import { Button } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import SaveIcon from '@material-ui/icons/Save';
import React from 'react';
import { Box } from '../../../UI';

export default function Leverage({ data }) {
	const { senior, mezz } = data;
	return (
		<ExpansionPanel style={{ background: '#eee' }}>
			<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
				<Typography variant="h6">
					<strong>Leverage</strong>
					<Tooltip title="Leverage assumptions to be inserted by the user" aria-label="info">
						<IconButton color="inherit" aria-label="menu">
							<InfoIcon style={{ fontSize: '16px' }} color="primary" />
						</IconButton>
					</Tooltip>
				</Typography>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails>
				<Box display="flex" flexDirection="column" width="100%">
					<Box display="flex" flexDirection="row" width="100%">
						<Box width="50%" pr="15px">
							<TableContainer>
								<Table aria-label="simple table">
									<TableHead>
										<TableRow>
											<TableCell align="left">
												<strong>Leverage (Senior)</strong>
											</TableCell>
											<TableCell />
											<TableCell />
										</TableRow>
									</TableHead>
									<TableBody>
										<TableRow>
											<TableCell align="left">
												<strong>Term (y)</strong>
											</TableCell>
											<TableCell align="right">{senior.term}</TableCell>
											<TableCell />
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>LtPP (%)</strong>
											</TableCell>
											<TableCell align="right">{senior.ltppPercent}%</TableCell>
											<TableCell align="right">£{senior.ltPPSen.toLocaleString()}</TableCell>
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>Interest Type</strong>
											</TableCell>
											<TableCell align="right">{senior.interestType}</TableCell>
											<TableCell />
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>Interest (% p.a.)</strong>
											</TableCell>
											<TableCell align="right">{senior.interest}%</TableCell>
											<TableCell />
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>Up-Front Fee</strong>
											</TableCell>
											<TableCell align="right">{senior.upFrontPercent}%</TableCell>
											<TableCell align="right">
												£{senior.upFrontFeeSen.toLocaleString()}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>Amortisation (% p.a.)</strong>
											</TableCell>
											<TableCell align="right">{senior.amortisation}%</TableCell>
											<TableCell />
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>Hedge Cost</strong>
											</TableCell>
											<TableCell align="right">£{senior.hedgeCost}</TableCell>
											<TableCell />
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</Box>
						<Box width="50%" pl="15px">
							<TableContainer>
								<Table aria-label="simple table">
									<TableHead>
										<TableRow>
											<TableCell align="left">
												<strong>Leverage (Mezz/SHL)</strong>
											</TableCell>
											<TableCell />
											<TableCell />
										</TableRow>
									</TableHead>
									<TableBody>
										<TableRow>
											<TableCell align="left">
												<strong>Term (y)</strong>
											</TableCell>
											<TableCell align="right">{mezz.term}</TableCell>
											<TableCell />
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>LtPP (%)</strong>
											</TableCell>
											<TableCell align="right">{mezz.ltppPercent}%</TableCell>
											<TableCell align="right">£{mezz.ltPPMez.toLocaleString()}</TableCell>
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>Interest Type</strong>
											</TableCell>
											<TableCell align="right">{mezz.interestType}</TableCell>
											<TableCell />
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>Interest (% p.a.)</strong>
											</TableCell>
											<TableCell align="right">{mezz.interest}%</TableCell>
											<TableCell />
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>Up-Front Fee</strong>
											</TableCell>
											<TableCell align="right">{mezz.upFrontPercent}%</TableCell>
											<TableCell align="right">£{mezz.upFrontFeeMez.toLocaleString()}</TableCell>
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>Amortisation (% p.a.)</strong>
											</TableCell>
											<TableCell align="right">{mezz.amortisation}%</TableCell>
											<TableCell />
										</TableRow>
										<TableRow>
											<TableCell align="left">
												<strong>Hedge Cost</strong>
											</TableCell>
											<TableCell align="right">£{mezz.hedgeCost}</TableCell>
											<TableCell />
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</Box>
					</Box>

					<Box display="flex" justifyContent="flex-end">
						<Button variant="contained" color="primary" startIcon={<SaveIcon />}>
							Save changes
						</Button>
					</Box>
				</Box>
			</ExpansionPanelDetails>
		</ExpansionPanel>
	);
}
